var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBloomingFlower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 998,
    height: 974,
    viewBox: "0 0 998 974",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.1
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 295.998,
    cy: 487,
    r: 216.683,
    transform: "rotate(30 295.998 487)",
    fill: "#A0CBCB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.1
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.457,
    cy: 630.544,
    r: 216.683,
    transform: "rotate(-15 355.457 630.544)",
    fill: "#A0CBCB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.1
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.457,
    cy: 343.456,
    r: 216.683,
    transform: "rotate(75 355.457 343.456)",
    fill: "#A0CBCB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.1
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.999,
    cy: 678,
    r: 216.683,
    transform: "rotate(-60 498.999 678)",
    fill: "#A0CBCB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.1
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 702.002,
    cy: 487,
    r: 216.683,
    transform: "rotate(30 702.002 487)",
    fill: "#A0CBCB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.1
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 642.545,
    cy: 343.456,
    r: 216.683,
    transform: "rotate(-15 642.545 343.456)",
    fill: "#A0CBCB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.1
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 642.545,
    cy: 630.544,
    r: 216.683,
    transform: "rotate(75 642.545 630.544)",
    fill: "#A0CBCB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.1
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.999,
    cy: 296,
    r: 216.683,
    transform: "rotate(-60 498.999 296)",
    fill: "#A0CBCB"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 498.999,
    cy: 487,
    r: 216.683,
    transform: "rotate(-60 498.999 487)",
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 498.999,
    cy: 487,
    r: 216.683,
    transform: "rotate(-60 498.999 487)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloomingFlower);
export default __webpack_public_path__ + "static/media/blooming_flower.6105787847fc6a25d2f996d0ed8e7c5d.svg";
export { ForwardRef as ReactComponent };